import _ from "lodash";
import ACLStore from "lib/aclStore";
import {
  generateConfigurationQueryVariables,
  skipPreloadConfigurationsQuery,
} from "ChildrenPage/modules/ChildrenPageUtils";
import { generateConfigurationQueryVariablesV2 } from "Utils/ConfigurationUtils/Utils";
import {
  getConfigurationQuery,
  getPreferenceQuery,
} from "ChildrenPage/modules/ChildrenPageQuery";
import client from "lib/apolloClient/client";
import {
  isPublicPlatformRoute,
  fetchOrganizationAndUserIdForPublicPost,
} from "Login/modules/LoginModule";

const fetchUserConfigurations = ({
  organizationId,
  modules,
  configurations,
}) => async () => {
  const resolvedOrgId = isPublicPlatformRoute()
    ? fetchOrganizationAndUserIdForPublicPost().organizationId
    : organizationId;

  const variables = modules
    ? {
        ...generateConfigurationQueryVariablesV2({
          src: "ORGANIZATION_LEVEL",
          organizationId: resolvedOrgId,
          modules,
        }),
        isAdminPage: false,
      }
    : generateConfigurationQueryVariables({
        src: "ORGANIZATION_LEVEL",
        organizationId: resolvedOrgId,
        fetchInitialLoadConfigurations: !skipPreloadConfigurationsQuery(),
        ...(!_.isEmpty(configurations) && { configurations }),
      });

  const newConfigurationResult = await client.query({
    query: getConfigurationQuery,
    variables: variables,
    fetchPolicy: "network-only",
  });
  const newConfigList = _.get(
    newConfigurationResult,
    "data.platform.configuration.0.configurations",
    []
  );

  ACLStore.updateConfig("ORGANIZATION", newConfigList);
  ACLStore.subscribeToContext("ORGANIZATION");
};

const fetchUserPreferences = ({ organizationId, modules }) => async () => {
  const resolvedOrgId = isPublicPlatformRoute()
    ? fetchOrganizationAndUserIdForPublicPost().organizationId
    : organizationId;

  const variables = modules
    ? {
        ...generateConfigurationQueryVariablesV2({
          src: "ORGANIZATION_LEVEL",
          organizationId: resolvedOrgId,
          modules,
        }),
        isAdminPage: false,
      }
    : generateConfigurationQueryVariables({
        src: "ORGANIZATION_LEVEL",
        organizationId: resolvedOrgId,
      });

  await client.query({
    query: getPreferenceQuery,
    variables: variables,
    fetchPolicy: "network-only",
  });
};

export { fetchUserConfigurations, fetchUserPreferences };
